module.exports = __webpack_public_path__ + "img/order_concat_servicer@2x.b56377e0.png";